// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CalculatorWrapperStyle-module--wrapper--2WqCp","calculator_wrapper_title":"CalculatorWrapperStyle-module--calculator_wrapper_title--3P7aD"};